export default {
      id: "icon-feu-usage",
      viewBox: "0 0 90.4 121.8",
      url: __webpack_public_path__ + "icons.svg#icon-feu",
      toString: function () {
        return this.url;
      }
    }